export default "__VITE_ASSET__Ct50tcJj__"